<template>
	<div class="page-in">
		<van-nav-bar :title="$t('订单详情')" fixed placeholder left-arrow z-index="99" @click-left="backLeft" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<div class="layui-container" v-if="detailData && detailData != null && detailData != 'null'">
				<div class="uc-breadcrumb">
					<el-link type="info" @click="back">
						<span class="iconfont icon-l-left"></span><span>{{$t('返回')}}</span>
					</el-link>
				</div>
				<div class="state-panel">
					<div class="state-lcol">
						<div class="state-top">{{$t('订单号')}}：{{detailData.order_sn}}</div>
						<div class="state-payTpey">
							<span v-if="detailData.pay_type == 1" >{{$t('在线支付')}}</span>
							<span v-else >{{$t('货到付款')}}</span>
						</div>
						<div class="state-txt">
							<span v-if="detailData.status == 0" class="text-primary">{{$t('待付款')}}</span>
							<span v-else-if="detailData.status == 1" class="text-primary">{{$t('待发货')}}</span>
							<span v-else-if="detailData.status == 2" class="text-warning">{{$t('待收货')}}</span>
							<span v-else-if="detailData.status == 3" class="text-primary">{{$t('待评价')}}</span>
							<span v-else-if="detailData.status == 4" class="text-gray">{{$t('已完成')}}</span>
							<span v-else-if="detailData.status == 5" class="text-danger">{{$t('已取消')}}</span>
						</div>
						<div class="state-btns">
							<template v-if="detailData.status == 0">
								<el-button v-if="detailData.pay_type == 3" @click="onPayShow()" round type="primary">{{$t('立即付款')}}</el-button>
								<el-button v-else @click="onPay(detailData.id)" round type="primary">{{$t('立即付款')}}</el-button>
							</template>
							
							<el-button v-else-if="detailData.status == 2 && detailData.pay_type == 1" @click="confirmOrder(detailData.id)" round>{{$t('确认收货')}}</el-button>
							<el-button v-else-if="detailData.status == 3" round @click="goComment(detailData.id,detailData.gid)">{{$t('去评价')}}</el-button>
							
						</div>
					</div>
					<div class="track-rcol flex-col">
						<div class="track-rtitle">{{$t('商品信息')}}</div>
						<div class="p-item">
							<div class="p-img" >
								<img :src="detailData.goods.img" alt="">
							</div>
							<div class="p-info">
								<ul>
									<li class="p-info-title">{{detailData.goods.title}}</li>
									<li>{{$t('价格')}}：{{formatNumber(detailData.goods.price)}} {{$t('VND')}}</li>
									<li>{{$t('下单时间')}}：{{detailData.created_at}}</li>
									<li>{{$t('规格')}}：{{detailData.sku}}</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="track-panel">
					<div class="track-lcol">
						<div class="track-rtitle">{{$t('货运信息')}}</div>
						<div class="track-items">
							<div class="track-item_row">
								<div class="track-label">
									{{$t('快递单号')}}：
								</div>
								<div class="track-value">
									{{detailData.tracking_number}}
								</div>
							</div>
							<div class="track-item_row">
								<div class="track-label">
									{{$t('发货时间')}}：
								</div>
								<div class="track-value">
									{{detailData.shipping_time}}
								</div>
							</div>
							<div class="track-item_row">
								<div class="track-label">
									{{$t('取消时间')}}：
								</div>
								<div class="track-value">
									{{detailData.cancellation_time}}
								</div>
							</div>
						</div>
					</div>
					<div class="track-lcol ">
						<div class="track-rtitle">{{$t('收货人信息')}}</div>
						<div class="track-items">
							<div class="track-item_row">
								<div class="track-label">
									{{$t('收货人')}}：
								</div>
								<div class="track-value">
									{{detailData.address_name}}
								</div>
							</div>
							<div class="track-item_row">
								<div class="track-label">
									{{$t('手机号')}}：
								</div>
								<div class="track-value">
									{{detailData.address_phone}}
								</div>
							</div>
							<div class="track-item_row">
								<div class="track-label">
									{{$t('地址')}}：
								</div>
								<div class="track-value" v-if="detailData.address_provinces">
									{{detailData.address_provinces}} - {{detailData.address_area}} - {{detailData.address_wards}}
								</div>
							</div>
							<div class="track-item_row">
								<div class="track-label">
									{{$t('详细地址')}}：
								</div>
								<div class="track-value" v-if="detailData">
									{{detailData.address_details}}
								</div>
							</div>
						</div>
					</div>
					<div class="track-rcol flex-col">
						<div class="track-rtitle">{{$t('物流信息')}}</div>
						<div class="track-scroll">
							<el-scrollbar ref="scrollbar" v-if="TrackingData && TrackingData.length > 0" style="height:300px;" >
								
								<div class="track-cell"  v-for="(item,index) in TrackingData" :key="index">
									<div class="track-cell_label">
										{{$t('快递单号')}}: {{item.bill_code}}
									</div>
									<div class="track-cell_label">
										{{$t('备注')}}: {{item.note}}
									</div>
									<ul class="track-list" >
										<li v-for="(item2,index2) in item.histories" :key="index2">
											<div class="time-label">
												{{item2.loc_time}}
											</div>
											<div class="flex-col">
												<div class="track-item">
													<div v-if="$helper.get('i18n_lang') == 'us'">
														{{item2.operation_en}}
													</div>
													<div v-if="$helper.get('i18n_lang') == 'vn'">
														{{item2.operation}}
													</div>
												</div>
												<div class="track-item">
													{{item2.city}} - {{item2.district}}
												</div>
											</div>
										</li>
									</ul>
								</div>
							</el-scrollbar>
							<empty v-else></empty>
						</div>
					</div>
				</div>
			</div>
		</div>
		<payBankDialog :isOrderPage="true" ref="payBankDialog"></payBankDialog>
	</div>
</template>
<script>
	import payBankDialog from "./components/payBankDialog.vue"
	import axios from 'axios';
	import empty from '@/components/empty.vue'
	import helper from '@/common/helper.js';
	import {
		order_detail_api,
		order_list_api,
		order_cancel_api,
		order_confirm_api,
		order_pay_api,
	} from "@/api/user"
	export default {
		components: {
			empty,
			payBankDialog
		},
		data() {
			return {
				orderid:'',
				detailData:null ,
				TrackingData:[],
				demo:[
					{}
				],
			}
		},
		methods: {
			backLeft(){
				this.$router.push('/category');
			},
			onPayShow(){
				this.$refs.payBankDialog.payInfoShow = true
			},
			async confirmOrder(oid) {
				await this.$confirm(this.$t('是否要确认收货?'), '', {
					confirmButtonText: this.$t('确定'),
					cancelButtonText: this.$t('取消'),
					type: 'warning'
				}).then(() => {
					let param = {
						id: oid,
					};
					if(!this.$store.state.isLoginStatu){
						param["uuid"] = helper.get('uuid') || ''
					}
					const loading = this.$loading({
						lock: true,
						text: '',
						spinner: 'loader',
						background: 'rgba(255, 255, 255, 0.3)'
					});
					order_confirm_api(param).then(res => {
						loading.close();
						if (res && res.data.code == 1) {
							this.successTips(res.data.msg)
							this.goUrl('/my-order')
						} else {
							this.errorTips(res.data.msg)
						}
					});
				}).catch(() => {});
			},
			async onPay(orderid) {
				let data = {
					id: orderid,
				}
				if(!this.$store.state.isLoginStatu){
					data["uuid"] = helper.get('uuid') || ''
				}
				const loading = this.$loading({
				  lock: true,
				  text: '',
				  spinner: 'loader',
				  background: 'rgba(255, 255, 255, 0.3)'
				});
				await order_pay_api(data).then(res => {
					if (res && res.data.code == 1) {
						this.platUrl(res.data.data)
					}else{
						this.errorTips(res.data.msg)
					}
				});
			},
			goComment(aid,gid){
				this.$router.push({ 
				  path: '/product-comment', 
				  query: {
					  aid: aid,
					  gid: gid
				  }
				})
			},
			async getOrderCancel(oid) {
				await this.$confirm(this.$t('是否要删除订单?'), '', {
					confirmButtonText: this.$t('确定'),
					cancelButtonText: this.$t('取消'),
					type: 'warning'
				}).then(() => {
					let param = {
						id: oid,
					};
					const loading = this.$loading({
						lock: true,
						text: '',
						spinner: 'loader',
						background: 'rgba(255, 255, 255, 0.3)'
					});
					order_cancel_api(param).then(res => {
						loading.close();
						if (res && res.data.code == 1) {
							this.successTips('订单删除成功')
							this.goUrl('/my-order')
						} else {
							this.errorTips(res.data.msg)
						}
					});
				}).catch(() => {});
			},
			async getProductData() {
				let param = {
					id: this.orderid,
				}
				if(!this.$store.state.isLoginStatu){
					param["uuid"] = helper.get('uuid') || ''
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await order_detail_api(param).then(res => {
					if (res && res.data.code == 1) {
						this.detailData = res.data.data
						if(this.detailData.tracking_number && this.detailData.tracking_number != ""){
							this.getTracking(this.detailData.tracking_number)
						}
					}
					loading.close()
				});
			},
			getTracking(sn) {
			    axios.get('https://apisandbox.ntlogistics.vn/v1/bill/tracking', {
			        headers: {
			            'username': 'bbeauty',
			            'password': 'dbea3cef248d01e6f4d3d61c6149a8fc482c1751'
			        },
			        params: {
			            bill_code: sn// 添加快递单号参数
			        }
			    })
			    .then(response => {
			        // 检查响应是否具有预期的结构
			        if (response.data && response.data.data) {
			            this.TrackingData = response.data.data;
			        } else {
			            console.error('响应结构异常:', response.data);
			        }
			    })
			    .catch(error => {
			        console.error('获取省份信息时出错:', error);
			    });
			},
		},
		mounted() {
			const orderid = this.$route.query.aid;
			if (orderid ) {
				this.orderid = orderid
				this.getProductData()
			}
		}
	};
</script>
<style scoped>
	.uc-breadcrumb {
		margin-bottom: 15px;
	}
	.track-cell{
		margin-bottom: 20px;
	}
	.track-item{
		margin-bottom:10px;
	}
	.track-list{
		position: relative;
		margin-top: 20px;
	}
	.track-list::before{
		content: '';
		position: absolute;
		width: 1px;
		height: 100%;
		left: 135px;
		background-color: #dfdfdf;
	}
	.track-list li::before{
		content: '';
		position: absolute;
		width: 8px;
		height: 8px;
		border-radius: 8px;
		background-color: #dfdfdf;
		left: 132px;
		top: 10px;
	}
	.track-list li:first-child::before{
		background-color: #000;
	}
	.track-list li{
		position: relative;
		display: flex;
		line-height: 25px;
		margin-bottom: 20px;
	}
	.time-label{
		margin-right: 20px;
		width: 130px;
		color: #666;
	}
	.track-cell_label{
		margin-bottom: 10px;
	}
	.state-btns{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 30px;
	}
	.track-item_row{
		display: flex;
		margin-bottom: 10px;
	}
	.track-item_row .track-label{
		color: #999;
		margin-right: 3px;
	}
	.track-item_row .track-value{
		flex: 1;
	}
	.p-item{
		display: flex;
	}
	.p-item .p-img{
		width: 160px;
		height: 160px;
		margin-right: 25px;
	}
	.p-item .p-img img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.p-info{
		flex: 1;
	}
	.p-info li{
		font-size: 14px;
		margin-bottom: 10px;
	}
	
	
	.page-in{
		background-color: #fafafa;
	}
	.state-txt{
		font-size: 32px;
	}
	.state-top{
		color: #999;
		font-size: 14px;
		margin-bottom: 30px;
	}
	.state-panel{
		background-color: #ffffff;
		display: flex;
		border-top: 3px solid #71b247;
		margin-bottom: 20px;
	}
	.state-panel .state-lcol {
	    width: 325px;
	    padding: 20px 0 38px;
		border-right: 1px solid #f1f1f1;
	    text-align: center;
	}
	.track-panel{
		display: flex;
		background: #fff;
		border: 1px solid #eee;
	}
	.track-panel .track-lcol {
	    width: 325px;
	    padding: 20px;
		border-right: 1px solid #f1f1f1;
	}
	.track-rcol{
		padding: 20px 30px;
	}
	.track-rtitle{
		margin-bottom: 20px;
		font-weight: bold;
	}
	.track-item_row{
		margin-bottom: 10px;
		font-size: 14px;
	}
	.state-payTpey{
		margin-bottom: 10px;
	}
	.p-info-title{
		font-weight: bold;
	}
	@media (max-width:992px) {
		.p-item .p-img{
			width: 120px;
			height: 120px;
		}
		.track-panel{
			display: block;
		}
		.state-panel .state-lcol{
			padding: 40px 0;
		}
		.state-panel{
			display: block;
		}
		.track-rcol{
			padding:0 20px 20px 20px;
		}
		.state-lcol,
		.track-lcol{
			width: 100%!important;
			border: 0;
		}
	}
	.track-scroll ::v-deep .empty-panel{
		height: auto;
		padding: 30px 0;
	}
	
</style>